.ad{justify-content:center;}